import {action, makeObservable, observable, runInAction} from 'mobx';
import {api} from '../../ApiFacade';
import {mainState} from '../../AppMainState';
import {confirmAction, showAlert, showDefaultError, showWarning} from '../../helpers/alerts';
import {showLoaderAsync} from '../../helpers/loaders';
import * as isemail from 'isemail';
import {UserStatus} from '../../swagger';

(window as any).global = window;
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-var-requires
window.Buffer = window.Buffer || require('buffer').Buffer;

export class SettingsViewState {
    @observable
    currentProjectId: string | null | undefined;
    @observable
    showUserForm: boolean = false;
    @observable
    userEmail: string = '';
    @observable
    newpassword?: string;
    @observable
    confirmnewpassword?: string;

    constructor() {
        makeObservable(this);
    }

    setProject(projectId: string | null | undefined) {
        makeObservable(this);
        this.currentProjectId = projectId;
        if (!this.currentProjectId && mainState.projects.length > 0) {
            this.currentProjectId = mainState.projects[0].projectId;
        }
    }

    deleteProject(projectId: string) {
        confirmAction('There is no way back', async () => {
            showLoaderAsync(api().projects.apiProjectsProjectIdDelete({
                projectId: projectId,
            }).then(() => {
                mainState.reloadProjects();
            }).catch(err => {
                showDefaultError(err);
            }));

        });
    }

    deleteLog(logId: string) {
        confirmAction('There is no way back', async () => {
            showLoaderAsync(
                api().logs.apiLogsLogIdDelete({
                    logId: logId,
                }).then(() => {
                    mainState.reloadProjects();
                }).catch(err => {
                    showDefaultError(err);
                }));

        });
    }

    deleteUser(projectId: string, userId: string) {
        confirmAction('There is no way back', async () => {
            showLoaderAsync(
                api().projects.apiProjectsUsersProjectIdUserIdDelete({
                    projectId: projectId,
                    userId: userId,
                }).then(() => {
                    mainState.reloadProjects();
                }).catch(err => {
                    showDefaultError(err);
                })
            );
        });
    }

    @action
    showAddUserForm() {
        this.showUserForm = true;
    }

    saveUser(projectId: string, email?: string) {
        const p = mainState.projects.find(x => x.projectId === projectId);

        if (!email) {
            showWarning('Empty email', 'Please provide email');
            return;
        }

        if (!isemail.validate(email)) {
            showWarning('Invalid email', 'Please provide correct email');
            return;
        }

        if (p && p.users) {
            const e = p.users.find(x => x.name === email);
            if (e) {
                showWarning('User already invited', 'Please search spam folder');
                return;
            }
        }

        showLoaderAsync(
            api().projects.apiProjectsUsersPost({
                addUserToProjectRequest: {
                    projectId,
                    email,
                }
            }).then((res) => {
                runInAction(() => {
                    this.userEmail = '';
                    this.showUserForm = false;
                });

                if (res.invitationSent) {
                    showAlert('Invitation sent', 'User will receive email with invitation', 'info');
                    if (p && p.users) {
                        p.users.push({
                            name: email,
                            status: UserStatus.Pending,
                        });
                    }
                } else {
                    mainState.reloadProjects();
                }
            }).catch(err => {
                showDefaultError(err);
            })
        );
    }

    @action
    setUserEmail(v: string) {
        this.userEmail = v.toLowerCase();
    }

    @action
    setCurrentProjectId(v: string | null | undefined) {
        this.currentProjectId = v;
    }
}
